import { useMemo } from 'react';

import { useAccountFundingParamsFieldsStateStore } from '../AccountFundingParams/stores';
import { useContributionFieldsStateStore } from '../Contribution/stores';
import { useInterestAccrualsStateStore } from '../InterestAccruals/stores';
import { useRolloverFieldsStateStore } from '../Rollover/stores';

export default () => {
  const rolloverStore = useRolloverFieldsStateStore((state) => state.sourceState);
  const accountFundingParamsStore = useAccountFundingParamsFieldsStateStore(
    (state) => state.sourceState,
  );
  const contributionConfigStore = useContributionFieldsStateStore((state) => state.sourceState);
  const interestAccrualsStore = useInterestAccrualsStateStore((state) => state.sourceState);
  const state = useMemo(() => ({
    ...accountFundingParamsStore,
    ...rolloverStore,
    ...contributionConfigStore,
    ...interestAccrualsStore,
  }), [accountFundingParamsStore, contributionConfigStore, interestAccrualsStore, rolloverStore]);
  return state;
};
